module.exports = __webpack_public_path__ + "assets/img/6b7163ee2b78604575143c58f3522418.ebfe8748.png";